/* eslint-disable react-hooks/exhaustive-deps */
import "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import GreenYes from "../../assets/image/GreenYes.svg";
import NO from "../../assets/image/No.svg";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import parsePythonStyleJson from "../banner/Function";
import FormLayout from "../RecipientManagement/FormLayout";
import InputField from "../RecipientManagement/InputField";
import LoadingButton from "../RecipientManagement/LoadingButton";
import ReactSelectField from "../RecipientManagement/ReactSelectField";
import FileUpload from "./FileUpload";
const CreateMachine = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    // defaultValues: {
    //   machine_type: { value: "ai_smart", label: "AI Smart Fridge" },
    // },
  });
  const [is_active, setIsActive] = useState(true);
  const [load, setLoad] = useState(false);
  const { websocket } = useContext(WebSocketContext);
  const { ClearFormSet, machineList, recipientList } = useSelector(
    (state) => state.adminReducers
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const machine_type = watch("machine_type");
  const [selectedAcquirers, setSelectedAcquirers] = useState([]);
  const [autoSelected, setAutoSelected] = useState(false);
  const [recipientData, setRecipientData] = useState(null);

  const getCheckedOptions = (type) => {
    // if (type === "ai_smart") {
    //   return ["ARgo MyBalance"];
    // } else
    if (type === "ai_smart_cooler") {
      return ["ARgo MyBalance", "NTT Online"];
    } else if (type === "arvdn") {
      return ["ARgo MyBalance", "Fiuu Offline"];
    } else if (type === "eshop1") {
      return ["ARgo MyBalance", "NTT Online", "NTT Offline"];
    } else if (type === "eshop2") {
      return ["ARgo MyBalance", "Fiuu Online", "Fiuu Offline"];
    } else {
      return [];
    }
  };
  const statusOptions = [
    // { value: "ai_smart", label: "AI Smart Fridge" },
    { value: "ai_smart_cooler", label: "AI Smart Cooler 1" },
    { value: "arvdn", label: "ARVDN QR 1" },
    { value: "eshop1", label: "eShop1" },
    { value: "eshop2", label: "eShop2" },
  ];
  const machineTextMap = {
    // ai_smart: "Payment Acquirer API",
    ai_smart_cooler: "AI Smart Cooler 1",
    arvdn: "ARVDN QR 1",
    eshop1: "eShop1",
    eshop2: "eShop2",
  };
  const options = [
    { label: "ARgo MyBalance", value: "ARgo MyBalance" },
    { label: "Fiuu Online", value: "Fiuu Online" },
    { label: "Fiuu Offline", value: "Fiuu Offline" },
    { label: "NTT Online", value: "NTT Online" },
    { label: "NTT Offline", value: "NTT Offline" },
  ];
  // const checkedValues = getCheckedOptions(machine_type?.value);
  const toggleAcquirer = (value) => {
    const allowed = getCheckedOptions(machine_type?.value);

    if (!allowed.includes(value)) return;

    setSelectedAcquirers((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };
  useEffect(() => {
    if (machine_type?.value) {
      const allowed = getCheckedOptions(machine_type.value);
      setAutoSelected(false);
      setSelectedAcquirers((prev) =>
        prev.filter((item) => allowed.includes(item))
      );
    }
  }, [machine_type]);
  useEffect(() => {
    if (machine_type?.value && !autoSelected) {
      const allowed = getCheckedOptions(machine_type.value);
      setSelectedAcquirers(allowed);
      setAutoSelected(true);
    }
  }, [machine_type, autoSelected]);

  useEffect(() => {
    if (params?.id) {
      const payload = {
        transmit: "single",
        url: "machine_detail",
        request: { machine_code: params?.id },
      };
      wsSend_request(websocket, payload);
    }
  }, [params?.id]);
  const machineListData = machineList?.list?.filter(
    (data) => data.machine_code === params?.id
  )[0];
  const matchedStatus = statusOptions.find(
    (option) =>
      option?.value?.toLowerCase() ===
      machineListData?.machine_type?.toLowerCase()
  );

  useEffect(() => {
    if (!machineListData) return;
    reset({
      machine_id: machineListData?.machine_code,
      merchant_name: machineListData?.acquirer_merchant_name,
      machine_name: machineListData?.machine_name,
      machine_address: machineListData?.machine_address,
      machine_type: matchedStatus,
      app_id: machineListData?.ai_smart_app_id,
      secret: machineListData?.ai_smart_secret_key,
      door_open_url: machineListData?.ai_smart_door_open_url,
      payment_call_back_url: machineListData?.ai_smart_payment_callback_url,
      kay: machineListData?.ai_smart_key,
      login_url: machineListData?.ai_smart_authentication_url,
      vendor_id_door_1: machineListData?.door_no_one,
      vendor_id_door_2: machineListData?.door_no_two,
      key: machineListData?.key,
      arvdn_merchant_id: machineListData?.arvdn_merchant_id,
      arvdn_payment_url: machineListData?.arvdn_payment_callback_url,
      arvdn_key: machineListData?.arvdn_key,
      arvdn_secret_key: machineListData?.arvdn_secret_key,
      app_code: machineListData?.arvdn_app_code,
      arvdn_payment_notification_callback_url:
        machineListData?.arvdn_payment_notification_callback_url,
      service_id: machineListData?.eshop_online_service_id,
      ntt_merchant_id: machineListData?.eshop_offline_merchant_id,
      passowrd: machineListData?.eshop_online_password,
      ntt_terminal_id: machineListData?.eshop_offline_terminal_id,
      eshop_callback_url: machineListData?.eshop_status_callback_url,
      eshop_code_online: machineListData?.eshop_nttonline_code,
      eshop_code_offline: machineListData?.eshop_nttoffline_code,
      eshop_query_callback_url: machineListData?.eshop_query_url,
      arvgo_eshop_code: machineListData?.eshop_arvgo_code,
      eshop_txn_status_callback_url: machineListData?.eshop_arvgo_callback_url,
      //below all keys for eshop2
      ai_smart_cooler_merchant_key:
        machineListData?.ai_smart_cooler_merchant_key, //*
      ai_smart_cooler_merchant_code:
        machineListData?.ai_smart_cooler_merchant_code, //*
      ai_smart_cooler_pre_auth_amount:
        machineListData?.ai_smart_cooler_pre_auth_amount, //*
      eshop2_arvdn_payment_url: machineListData?.eshop2_arvdn_payment_url,
      eshop2_arvdn_payment_return_url:
        machineListData?.eshop2_arvdn_payment_return_url,
      eshop2_arvdn_payment_cancel_url:
        machineListData?.eshop2_arvdn_payment_cancel_url,
      eshop2_merchant_id: machineListData?.eshop2_merchant_id,
      eshop2_key: machineListData?.eshop2_key,
      eshop2_secret_key: machineListData?.eshop2_secret_key,
      eshop2_app_code: machineListData?.eshop2_app_code,
      eshop2_offline_app_code: machineListData?.eshop2_offline_app_code,
      eshop2_offline_secret_key: machineListData?.eshop2_offline_secret_key,
      eshop2_arvdn_offline_payment_url:
        machineListData?.eshop2_arvdn_offline_payment_url,
      eshop2_txn_status_callback_url:
        machineListData?.eshop2_txn_status_callback_url,
      eshop2_arvgo_code:
        matchedStatus?.value === "eshop2"
          ? machineListData?.eshop_arvgo_code
          : "",

      // eshop2_arvdn_payment_url:
      //   matchedStatus?.value === "eshop2"
      //     ? machineListData?.arvdn_payment_callback_url
      //     : "",
      // eshop2_merchant_id:
      //   matchedStatus?.value === "eshop2"
      //     ? machineListData?.arvdn_merchant_id
      //     : "",
      // eshop2_key:
      //   matchedStatus?.value === "eshop2" ? machineListData?.arvdn_key : "",
      // eshop2_secret_key:
      //   matchedStatus?.value === "eshop2"
      //     ? machineListData?.arvdn_secret_key
      //     : "",
      // eshop2_app_code:
      //   matchedStatus?.value === "eshop2"
      //     ? machineListData?.arvdn_app_code
      //     : "",

      eshop2_ntt_merchant_id:
        matchedStatus?.value === "eshop2"
          ? machineListData?.eshop_offline_merchant_id
          : "",
      eshop2_ntt_terminal_id:
        matchedStatus?.value === "eshop2"
          ? machineListData?.eshop_offline_terminal_id
          : "",
      eshop2_query_callback_url:
        matchedStatus?.value === "eshop2"
          ? machineListData?.eshop_query_url
          : "",
      eshop2_code_ntt_offline:
        matchedStatus?.value === "eshop2"
          ? machineListData?.eshop_nttoffline_code
          : "",
    });
    setIsActive(machineListData?.is_active);
    const certificateObj = parsePythonStyleJson(
      machineListData?.eshop_certificate
    );
    const privateKeyObj = parsePythonStyleJson(
      machineListData?.eshop_private_key
    );
    const eshop2_certificate =
      matchedStatus?.value === "eshop2"
        ? parsePythonStyleJson(machineListData?.eshop_certificate)
        : "";
    const eshop2_private_key =
      matchedStatus?.value === "eshop2"
        ? parsePythonStyleJson(machineListData?.eshop_private_key)
        : "";
    setValue("certificate", certificateObj);
    setValue("privateKey  ", privateKeyObj);
    setValue("eshop2_certificate", eshop2_certificate);
    setValue("eshop2_private_key", eshop2_private_key);
    setRecipientData({
      value: machineListData.recipient_id ?? "",
      label: machineListData.recipient_name ?? "",
    });
  }, [params?.id, machineListData]);

  const onSubmit = (data) => {
    const machineType = machine_type?.value;

    const commonPayload = {
      machine_code: data.machine_id,
      acquirer_merchant_name: data.merchant_name,
      recipient_name: recipientData?.label,
      recipient_id: recipientData?.value,
      machine_name: data.machine_name,
      machine_type: machineType,
      machine_address: data.machine_address,
      key: data.key,
      is_active: is_active,
      arvgo_mybalance: selectedAcquirers.includes("ARgo MyBalance"),
      fiuu: selectedAcquirers.includes("Fiuu Online"),
      fiuu_offline: selectedAcquirers.includes("Fiuu Offline"),
      ntt_online: selectedAcquirers.includes("NTT Online"),
      ntt_offline: selectedAcquirers.includes("NTT Offline"),
    };
    const typeFields = {
      ai_smart: {
        ai_smart_app_id: data?.app_id,
        ai_smart_secret_key: data?.secret,
        ai_smart_door_open_url: data?.door_open_url,
        ai_smart_payment_callback_url: data?.payment_call_back_url,
        ai_smart_key: data?.kay,
        ai_smart_authentication_url: data?.login_url,
        door_no_one: data?.vendor_id_door_1,
        door_no_two: data?.vendor_id_door_2,
      },
      ai_smart_cooler: {
        ai_smart_app_id: data?.app_id,
        ai_smart_secret_key: data?.secret,
        ai_smart_door_open_url: data?.door_open_url,
        ai_smart_payment_callback_url: data?.payment_call_back_url,
        ai_smart_key: data?.kay,
        ai_smart_authentication_url: data?.login_url,
        door_no_one: data?.vendor_id_door_1,
        door_no_two: data?.vendor_id_door_2,
        ai_smart_cooler_merchant_key: data?.ai_smart_cooler_merchant_key, //*
        ai_smart_cooler_merchant_code: data?.ai_smart_cooler_merchant_code, //*
        ai_smart_cooler_pre_auth_amount: data?.ai_smart_cooler_pre_auth_amount, //*
      },
      arvdn: {
        arvdn_merchant_id: data.arvdn_merchant_id,
        arvdn_payment_callback_url: data.arvdn_payment_url,
        arvdn_key: data.arvdn_key,
        arvdn_secret_key: data.arvdn_secret_key,
        arvdn_app_code: data.app_code,
        arvdn_payment_notification_callback_url:
          data.arvdn_payment_notification_callback_url,
      },
      eshop1: {
        eshop_online_service_id: data.service_id,
        eshop_offline_merchant_id: data.ntt_merchant_id,
        eshop_nttoffline_code: data.eshop_code_offline ?? "",
        eshop_offline_terminal_id: data.ntt_terminal_id,
        eshop_online_password: data.passowrd,
        eshop_status_callback_url: data.eshop_callback_url,
        eshop_nttonline_code: data.eshop_code_online,
        eshop_query_url: data.eshop_query_callback_url,

        eshop_arvgo_code: data.arvgo_eshop_code ?? "",
        eshop_arvgo_callback_url: data.eshop_txn_status_callback_url,

        eshop_certificate: data.certificate,
        eshop_private_key: data.privateKey,
      },
      eshop2: {
        //ARVgo MyBalance
        eshop2_txn_status_callback_url: data?.eshop2_txn_status_callback_url,
        // eshop2_arvgo_code:data?.eshop2_arvgo_code,
        // //Fiuu
        eshop2_arvdn_payment_url: data?.eshop2_arvdn_payment_url,
        eshop2_arvdn_payment_return_url: data?.eshop2_arvdn_payment_return_url,
        eshop2_arvdn_payment_cancel_url: data?.eshop2_arvdn_payment_cancel_url,
        eshop2_merchant_id: data?.eshop2_merchant_id,
        eshop2_key: data?.eshop2_key,
        eshop2_secret_key: data?.eshop2_secret_key,
        eshop2_app_code: data?.eshop2_app_code,
        eshop2_offline_app_code: data?.eshop2_offline_app_code,
        eshop2_offline_secret_key: data?.eshop2_offline_secret_key,
        eshop2_arvdn_offline_payment_url:
          data?.eshop2_arvdn_offline_payment_url,
        // // NTT Offline && certificate
        // eshop2_ntt_merchant_id:data?.eshop2_ntt_merchant_id,
        // eshop2_ntt_terminal_id:data?.eshop2_ntt_terminal_id,
        // eshop2_query_callback_url:data?.eshop2_query_callback_url,
        // eshop2_code_ntt_offline:data?.eshop2_code_ntt_offline,
        // eshop2_certificate: data?.eshop2_certificate,
        // eshop2_private_key: data?.eshop2_private_key,
      },
      //Fiuu
      arvdn_merchant_id: data?.eshop2_merchant_id,
      arvdn_payment_callback_url: data?.eshop2_arvdn_payment_url,
      arvdn_key: data?.eshop2_key,
      arvdn_secret_key: data?.eshop2_secret_key,
      arvdn_app_code: data?.eshop2_app_code,
      // arvgo
      eshop_status_callback_url: data?.eshop2_txn_status_callback_url,
      eshop_arvgo_code: data?.eshop2_arvgo_code,
      //ntt ofline
      eshop_offline_merchant_id: data?.eshop2_ntt_merchant_id,
      eshop_nttoffline_code: data?.eshop2_code_ntt_offline,
      eshop_offline_terminal_id: data?.eshop2_ntt_terminal_id,
      eshop_query_url: data?.eshop2_query_callback_url,

      eshop_certificate: data?.eshop2_certificate,
      eshop_private_key: data?.eshop2_private_key,
    };
    setLoad(true);
    const payload = {
      transmit: "single",
      url: params?.id ? "machine_edit" : "machine_add",
      request: {
        ...commonPayload,
        ...(typeFields[machineType] || {}),
        ...(params?.id && { id: machineListData?.id }),
      },
    };
    wsSend_request(websocket, payload);
  };

  useEffect(() => {
    const payload2 = {
      transmit: "single",
      url: "user_list",
      request: {
        status: "",
        user_type: "recipient",
        limit: "10000000",
        page_no: "1",
        search: "",
        order_by: "-updated_at",
      },
    };
    wsSend_request(websocket, payload2);
  }, [websocket]);

  useEffect(() => {
    if (
      (ClearFormSet?.url === "machine_add" ||
        ClearFormSet?.url === "machine_edit") &&
      ClearFormSet?.action === 200
    ) {
      navigate("/machine-management");
      setLoad(false);
    } else {
      setLoad(false);
    }
    if (ClearFormSet?.url) {
      const timeout = setTimeout(() => {
        dispatch(ClearFormSetFutios({ url: "", action: "" }));
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [ClearFormSet, dispatch, navigate]);

  return (
    <>
      <FormLayout title={params?.id ? "Edit Machine" : "Add New Machine"}>
        <form onSubmit={handleSubmit(onSubmit)} className="container">
          <div className="row">
            <div className="col-md-4 Height">
              <InputField
                label="Machine Id"
                name="machine_id"
                register={register}
                required
                errors={errors}
                placeholder="Enter Machine Id"
              />
            </div>
            <div className="col-md-4 Height">
              <InputField
                label="Acquirer Merchant Name"
                name="merchant_name"
                register={register}
                required
                errors={errors}
                placeholder="Enter Acquirer Merchant Name"
              />
            </div>
            <div className="col-md-4 Height">
              {/* <InputField
                label="Recipient Name"
                name="recipient_name"
                register={register}
                required={false}
                errors={""}
                // disabled
                placeholder="Enter Recipient Name"
              /> */}
              <label className="form-label label_class_name_for_input">
                Recipient Name
              </label>
              <Select
                value={recipientData}
                onChange={(e) => setRecipientData(e)}
                options={recipientList?.data?.map((item) => ({
                  value: item?.id,
                  label: item?.username,
                }))}
                isClearable
                // label="Recipient Name"
                classNamePrefix="godown-select "
                placeholder={"Enter Recipient Name"}
              />
            </div>
            <div className="col-md-4 Height">
              <InputField
                label="Machine Name"
                name="machine_name"
                register={register}
                required
                errors={errors}
                placeholder="Enter Machine Name"
              />
            </div>
            <div className="col-md-4 Height">
              <ReactSelectField
                label="Type"
                name="machine_type"
                control={control}
                errors={errors}
                required={true}
                options={statusOptions}
              />
            </div>
            <div className="col-md-4 Height">
              <h5 className="label_class_name_for_input mb-2">
                Payment Acquirer API
              </h5>
              {options?.map((row) => {
                const allowed = getCheckedOptions(machine_type?.value);
                const isAllowed = allowed.includes(row.value);
                const isChecked = selectedAcquirers.includes(row.value);

                return (
                  <div
                    className="d-flex gap-2"
                    key={row.value}
                    onClick={() => isAllowed && toggleAcquirer(row.value)}
                    style={{
                      cursor: isAllowed ? "pointer" : "not-allowed",
                      opacity: isAllowed ? 1 : 0.4,
                    }}
                  >
                    <div
                      className="payment_acquirer_div"
                      style={{
                        backgroundColor: isChecked ? "#ddf2ea" : "#F2F2F2",
                        border: isChecked
                          ? "1px solid #ddf2ea"
                          : "1px solid #E0E0E0",
                      }}
                    >
                      <img
                        src={isChecked ? GreenYes : NO}
                        alt={isChecked ? "Yes" : "No"}
                        style={{
                          width: isChecked ? "20px" : "8px",
                          height: isChecked ? "20px" : "8px",
                        }}
                      />
                    </div>

                    <p style={{ marginBottom: "5px" }}>{row.label}</p>
                  </div>
                );
              })}
            </div>

            <div className="col-md-4  Height">
              <InputField
                label="Machine Address"
                name="machine_address"
                register={register}
                required
                errors={errors}
                placeholder="Enter Machine Address"
              />
            </div>
            <div className="Height  col-md-4 d-flex align-items-center">
              <div className="d-flex align-items-center gap-2">
                <Form.Check
                  type="switch"
                  id={`switch-id-for-status`}
                  checked={is_active}
                  className=""
                  onChange={(e) => setIsActive(e.target.checked)}
                />
                <span className="new_status_class label_class_name_for_input">
                  Status
                </span>
              </div>
            </div>
          </div>
          {machine_type?.value && (
            <>
              <div className="new_line_class"></div>
              <p className="header-text mb-4 mt-2">
                {machineTextMap[machine_type?.value]}
              </p>
            </>
          )}

          {/* {machine_type?.value === "ai_smart" && (
            <>
              <div className="row">
                <div className="col-md-6 Height">
                  <InputField
                    label="Vend ID (Door 1)"
                    name="vendor_id_door_1"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter Vend ID"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Vend ID (Door 2) Optional"
                    name="vendor_id_door_2"
                    register={register}
                    required={false}
                    errors={""}
                    placeholder="Enter Vend ID (Optional)"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Login / Authenticate URL"
                    name="login_url"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter URL"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="APP ID"
                    name="app_id"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter App ID"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Door Open URL"
                    name="door_open_url"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter URL"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Secret"
                    name="secret"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter Secret Code"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Payment Callback URL"
                    name="payment_call_back_url"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter URL"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Key"
                    name="kay"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter URL"
                  />
                </div>
              </div>
            </>
          )} */}
          {machine_type?.value === "ai_smart_cooler" && (
            <>
              <div className="row">
                <div className="col-md-6 Height">
                  <InputField
                    label="Vend ID (Door 1)"
                    name="vendor_id_door_1"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter Vend ID"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Vend ID (Door 2) Optional"
                    name="vendor_id_door_2"
                    register={register}
                    required={false}
                    errors={""}
                    placeholder="Enter Vend ID (Optional)"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Login / Authenticate URL"
                    name="login_url"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter URL"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="APP ID"
                    name="app_id"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter App ID"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Door Open URL"
                    name="door_open_url"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter URL"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Secret"
                    name="secret"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter Secret Code"
                  />
                </div>
                <div className="col-md-6 Height">
                  <InputField
                    label="Key"
                    name="key"
                    register={register}
                    required={true}
                    errors={errors}
                    placeholder="Enter URL"
                  />
                </div>
              </div>
              {selectedAcquirers.includes("ARgo MyBalance") && (
                <>
                  <div className="new_line_class"></div>
                  <p className="header-text mb-4 mt-2">ARgo MyBalance</p>
                  <div className="row">
                    <div className="col-md-6 Height">
                      <InputField
                        label="Payment Callback URL"
                        name="payment_call_back_url"
                        register={register}
                        required={true}
                        errors={errors}
                        placeholder="Enter URL"
                      />
                    </div>
                  </div>
                </>
              )}
              {selectedAcquirers.includes("NTT Online") && (
                <>
                  <div className="new_line_class"></div>
                  <p className="header-text mb-4 mt-2">NTT Online</p>
                  <div className="row">
                    <div className="col-md-6 Height">
                      <InputField
                        label="Merchant Key"
                        name="ai_smart_cooler_merchant_key"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter Merchant Key"
                      />
                    </div>
                    <div className="col-md-6 Height">
                      <InputField
                        label="Merchant Code"
                        name="ai_smart_cooler_merchant_code"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter Merchant Code"
                      />
                    </div>
                    <div className="col-md-6 Height">
                      <InputField
                        label="Pre-Auth Amount"
                        name="ai_smart_cooler_pre_auth_amount"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter pre-auth amount"
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {machine_type?.value === "arvdn" && (
            <>
              <div className="row">
                <div className="col-md-6 Height">
                  <InputField
                    label="Key"
                    name="key"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter Key"
                  />
                </div>
              </div>
              {selectedAcquirers.includes("ARgo MyBalance") && (
                <>
                  <div className="new_line_class"></div>
                  <p className="header-text mb-4 mt-2">ARgo MyBalance</p>
                  <div className="row">
                    <div className="col-md-6 Height">
                      <InputField
                        label="ARVDN Payment Status Callback URL"
                        name="arvdn_payment_url"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter URL"
                      />
                    </div>
                  </div>
                </>
              )}
              {selectedAcquirers.includes("Fiuu Offline") && (
                <>
                  <div className="new_line_class"></div>
                  <p className="header-text mb-4 mt-2">Fiuu Offline</p>
                  <div className="row">
                    <div className="col-md-6 Height">
                      <InputField
                        label="Merchant ID "
                        name="arvdn_merchant_id"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter Merchant Id"
                      />
                    </div>
                    <div className="col-md-6 Height">
                      <InputField
                        label="Secret Key"
                        name="arvdn_secret_key"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter Secret Key"
                      />
                    </div>
                    <div className="col-md-6 Height">
                      <InputField
                        label="App Code"
                        name="app_code"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter App Code"
                      />
                    </div>
                    <div className="col-md-6 Height">
                      <InputField
                        label="ARVDN Payment Notification Callback URL"
                        name="arvdn_payment_notification_callback_url"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter URL"
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {machine_type?.value === "eshop1" && (
            <>
              <div className="row">
                <div className="col-md-6 Height">
                  <InputField
                    label="Key"
                    name="key"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter eShop1 Code"
                  />
                </div>
                <div className="col-md-6 Height"> </div>
                {/* NTT Online */}
                {selectedAcquirers.includes("NTT Online") && (
                  <div className="col-md-6">
                    <p className="header-text">NTT Online</p>
                    <InputField
                      label="Service ID"
                      name="service_id"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Service ID"
                    />
                    <InputField
                      label="Password"
                      name="passowrd"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Password"
                      type="passowrd"
                    />
                    <InputField
                      label="eShop1 TXN Status Callback URL"
                      name="eshop_callback_url"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter URL"
                    />
                  </div>
                )}
                {selectedAcquirers.includes("NTT Offline") && (
                  <div className="col-md-6 ">
                    <p className="header-text">NTT Offline</p>
                    <InputField
                      label="Merchant ID"
                      name="ntt_merchant_id"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Merchant ID"
                    />
                    <InputField
                      label="Terminal ID"
                      name="ntt_terminal_id"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Terminal ID"
                    />
                    <div style={{ height: "85px" }}>
                      <h5 className="label_class_name_for_input mb-1">
                        {" "}
                        Signed Certificate & Private Key{" "}
                        <span style={{ color: "#FF3939" }}>*</span>
                      </h5>
                      <div className="d-flex gap-2 col-md-12">
                        <FileUpload
                          label=""
                          name="certificate"
                          nameInsideDiv="Upload Certificate"
                          register={register}
                          required={
                            machine_type?.value === "eshop1" ? true : false
                          }
                          errors={errors}
                          setValue={setValue}
                          accept=".pem"
                          getValues={getValues}
                        />
                        <FileUpload
                          label=""
                          name="privateKey"
                          nameInsideDiv="Upload Private Key"
                          register={register}
                          required={
                            machine_type?.value === "eshop1" ? true : false
                          }
                          errors={errors}
                          setValue={setValue}
                          accept=".key"
                          getValues={getValues}
                        />
                      </div>
                    </div>
                    <InputField
                      label="eShop1 Query Result Callback URL"
                      name="eshop_query_callback_url"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter URL"
                    />
                    {/* <InputField
                    label="eShop Code"
                    name="eshop_code_offline"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter eShop Code"
                  /> */}
                  </div>
                )}
                {/* NTT Offline */}
              </div>
              {selectedAcquirers.includes("ARgo MyBalance") && (
                <>
                  <div className="new_line_class"></div>
                  <p className="header-text mb-4 mt-2">ARVgo MyBalance</p>
                  <div className="row">
                    <div className="col-md-6 Height">
                      <InputField
                        label="eShop1 TXN Status Callback URL"
                        name="eshop_txn_status_callback_url"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter URL"
                      />
                    </div>
                    <div className="col-md-6 Height">
                      {/* <InputField
      label="eShop Code"
      name="arvgo_eshop_code"
      register={register}
      required
      errors={errors}
      placeholder="Enter eShop Code"
    /> */}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {machine_type?.value === "eshop2" && (
            <>
              <div className="row">
                <div className="col-md-6 Height">
                  <InputField
                    label="Key"
                    name="key"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter eshop2 Code"
                  />
                </div>
                <div className="col-md-6 Height"> </div>
                {selectedAcquirers.includes("Fiuu Online") && (
                  <div className="col-md-6">
                    <p className="header-text">Fiuu Online</p>
                    <InputField
                      label="Merchant ID "
                      name="eshop2_merchant_id"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Merchant Id"
                    />
                    <InputField
                      label="Verify Key"
                      name="eshop2_key"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Verify Key"
                    />
                    <InputField
                      label="Secret Key"
                      name="eshop2_secret_key"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Secret Key"
                    />
                    <InputField
                      label="eshop2 Payment Result Callback URL"
                      name="eshop2_arvdn_payment_url"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter URL"
                    />
                    <InputField
                      label="eshop2 Return URL"
                      name="eshop2_arvdn_payment_return_url"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter URL"
                    />{" "}
                    <InputField
                      label="eshop2 Cancel URL"
                      name="eshop2_arvdn_payment_cancel_url"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter URL"
                    />
                  </div>
                )}
                {/* <div className="col-md-6 ">
                  <p className="header-text">NTT Offline</p>
                  <InputField
                    label="eshop2 Merchant ID"
                    name="eshop2_ntt_merchant_id"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter Merchant ID"
                  />
                  <InputField
                    label="eshop2 Terminal ID"
                    name="eshop2_ntt_terminal_id"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter Terminal ID"
                  />
                  <div style={{ height: "95px" }}>
                    <h5 className="label_class_name_for_input mb-1">
                      {" "}
                      Signed Certificate & Private Key{" "}
                      <span style={{ color: "#FF3939" }}>*</span>
                    </h5>
                    <div className="d-flex gap-2 col-md-12">
                      <FileUpload
                        label=""
                        name="eshop2_certificate"
                        nameInsideDiv="Upload Certificate"
                        register={register}
                        required={
                          machine_type?.value === "eshop2" ? true : false
                        }
                        errors={errors}
                        setValue={setValue}
                        accept=".pem"
                        getValues={getValues}
                      />
                      <FileUpload
                        label=""
                        name="eshop2_private_key"
                        nameInsideDiv="Upload Private Key"
                        register={register}
                        required={
                          machine_type?.value === "eshop2" ? true : false
                        }
                        errors={errors}
                        setValue={setValue}
                        accept=".key"
                        getValues={getValues}
                      />
                    </div>
                  </div>
                  <InputField
                    label="eShop2 Query Result Callback URL"
                    name="eshop2_query_callback_url"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter URL"
                  />
                  <InputField
                    label="eShop2 Code"
                    name="eshop2_code_ntt_offline"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter eShop Code"
                  />
                </div> */}
                {selectedAcquirers.includes("Fiuu Offline") && (
                  <div className="col-md-6">
                    <p className="header-text">Fiuu Offline</p>
                    {!selectedAcquirers.includes("Fiuu Online") && (
                      <InputField
                        label="Merchant ID "
                        name="eshop2_merchant_id"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter Merchant Id"
                      />
                    )}
                    <InputField
                      label="App Code"
                      name="eshop2_offline_app_code"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter App Code"
                    />
                    <InputField
                      label="Secret Key"
                      name="eshop2_offline_secret_key"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter Secret Key"
                    />
                    <InputField
                      label="eshop2 Payment Notification Callback URL"
                      name="eshop2_arvdn_offline_payment_url"
                      register={register}
                      required
                      errors={errors}
                      placeholder="Enter URL"
                    />
                    {/* <InputField
                    label="eshop2 Merchant ID "
                    name="eshop2_merchant_id"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter Merchant Id"
                  />
                  <InputField
                    label="eshop2 Key"
                    name="eshop2_key"
                    register={register}
                    required
                    errors={errors}
                    placeholder="Enter Key"
                  /> */}
                  </div>
                )}
              </div>
              {selectedAcquirers.includes("ARgo MyBalance") && (
                <>
                  <div className="new_line_class"></div>
                  <p className="header-text mb-4 mt-2">ARVgo MyBalance</p>
                  <div className="row">
                    <div className="col-md-6 Height">
                      <InputField
                        label="eShop2 TXN Status Callback URL"
                        name="eshop2_txn_status_callback_url"
                        register={register}
                        required
                        errors={errors}
                        placeholder="Enter URL"
                      />
                    </div>
                    <div className="col-md-6 Height">
                      {/* <InputField
      label="eShop2 Code"
      name="eshop2_arvgo_code"
      register={register}
      required
      errors={errors}
      placeholder="Enter eShop Code"
    /> */}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          <div className="row">
            <div className="col-12 d-flex gap-2 mt-3">
              <LoadingButton loading={load} text="Save" />
            </div>
          </div>
        </form>
      </FormLayout>
    </>
  );
};

export default CreateMachine;
